import { ChangeDetectionStrategy, Component, inject, input } from '@angular/core';
import { MatIcon } from '@angular/material/icon';
import { AppLinksService } from '../../../api/services/app-links.service';

@Component({
  selector: 'app-business-account-cta',
  imports: [MatIcon],
  templateUrl: './business-account-cta.component.html',
  styleUrl: './business-account-cta.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class BusinessAccountCtaComponent {
  heading = input.required<string>();

  text = input.required<string>();

  protected readonly appLinks = inject(AppLinksService);
}
